<template>
    <div id="app"><router-view></router-view></div>
</template>

<script>
export default {
    name: 'App',
    created() {
          console.log('APP.VUE'); 
        },
}
</script>

<style>
#app {
    font-family: '微软雅黑', Helvetica, Arial, sans-serif, 'Avenir';
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 14px !important;
    padding: 0px;
    text-decoration: none;
}

a {
    text-decoration: none;
}

textarea {
    padding: 5px 8px;
    font-family: "微软雅黑", "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.pdiv {
    margin-bottom: 8px;
    border: solid 1px #DDD;
    border-radius: 5px;
    padding: 6px 8px;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
    color: #555;
    font-size: 14px;
    line-height: 24px;
    box-sizing: border-box;
    position: relative;
}

.fulldiv {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    /*border: solid 0px #ff0000;*/
    position: relative;
    box-sizing: border-box;
}

.autodiv {
    flex: 1 1 auto;
    overflow-y: auto;
    width:100%;
    /*background-color: #ffcccc;*/
}

/**颜色处理 */
.white {
    color: #fff;
}
.grey{
    color:#D3D3D3;
}

.red {
    color: #FF0000;
}

.darkred {
    color: #CC0000;
}

.blue {
    color: #0000ff;
}

.darkblue {
    color: #0000CC;
}

.green {
    color: #00CC00;
}

.darkgreen {
    color: #009900
}

.yellow {
    color: #FFFF00;
}

/**字号处理 */
.f12 {
    font-size: 12px !important;
}

.f13 {
    font-size: 13px !important;
}

.f14 {
    font-size: 14px !important;
}

.f15 {
    font-size: 15px !important;
}

.f16 {
    font-size: 16px !important;
}

.f17 {
    font-size: 17px !important;
}

.f18 {
    font-size: 18px !important;
}

.f19 {
    font-size: 19px !important;
}

.f20 {
    font-size: 20px !important;
}

.f22 {
    font-size: 22px !important;
}

.f24 {
    font-size: 24px !important;
}

.f36 {
    font-size: 36px !important;
}

.f48 {
    font-size: 48px !important;
}

.b {
    font-weight: 900;
}
.w80 {
    width: 80px;
}
.w120 {
    width: 120px;
}
.w180{
    width: 180px;
}
.w190 {
    width: 190px;
}
.w210{
    width: 210px;
}
.w240{
    width: 240px;
}
.w270{
    width: 240px;
}
.h16{
    line-height: 16px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue